<template>
  <CSpinner color="primary" v-if="isEmpty(coachByUuid(coachesUuid))" />
</template>
  
<script>
import { isEmpty } from "@/utilities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SkeletonLoader",
  props: {
    coachesUuid: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("coaches", ["coachByUuid"]),
  },
  methods: {
    isEmpty,
    ...mapActions('coaches', ['getCoachById'])
  },
  mounted() {
    // We immediately load the component if
    // `IntersectionObserver` is not supported.
    if (!('IntersectionObserver' in window)) {
      componentFactory().then(resolveComponent);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      // Use `intersectionRatio` because of Edge 15's
      // lack of support for `isIntersecting`.
      // See: https://github.com/w3c/IntersectionObserver/issues/211
      if (entries[0].intersectionRatio <= 0) return;

      // Cleanup the observer when it's not
      // needed anymore.
      observer.unobserve(this.$el);
      // The `componentFactory()` resolves
      // to the result of a dynamic `import()`
      // which is passed to the `resolveComponent()`
      // function.
      componentFactory().then(resolveComponent);
    });
    // We observe the root `$el` of the
    // mounted loading component to detect
    // when it becomes visible.
    observer.observe(this.$el);
  },
};
</script>